/* eslint-disable no-tabs */
import React from "react";
import SelectSearch, * as SelectSearchUtils from "react-select-search";
import classNames from "classnames";

import * as Utils from "../../utils";
import { Logger } from "../../utils/Logger";

import classes from "./TimeZoneSelector.module.scss";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new Logger("TimeZoneSelector");

interface IProps {
	disabled?: boolean;
}

export const TimeZoneSelector = ({ disabled }: IProps): JSX.Element => {
	const timeZones: (Utils.time.ITimeZone | null)[] = React.useMemo(() => Utils.time.timeZones(), []);
	const currentTz = Utils.time.getTz();

	const selectSearchOnChangeHandler = (selectedValue: SelectSearchUtils.SelectedOptionValue | SelectSearchUtils.SelectedOptionValue[]): void => {
		if (!disabled && typeof selectedValue === "string" && selectedValue !== currentTz) {
			Utils.time.setTz(selectedValue as string ?? "");
			window.location.reload();
		}
	};

	return (
		<div className={classNames(classes.tzSelector)}>
			<SelectSearch
				className={classNames("select-search", classes.tzSelector_search)}
				options={timeZones.map(_ => ({ name: _?.displayName ?? "", value: _?.name ?? "" }))}
				value={currentTz}
				search={true}
				filterOptions={SelectSearchUtils.fuzzySearch}
				placeholder="Select Timezone"
				onChange={selectSearchOnChangeHandler}
				disabled={disabled}
			/>
		</div>
	);
};
